import React from 'react'
import {Link} from "react-router-dom";
import projects from '../projects';
import wordmark from '../Images/joyastick-wordmark.png';
import wordmarkOrange from '../Images/joyastick-wordmark-orange.png';
import { EMAIL, links } from '../links';
import icons from '../icons';
import transition from "../transition";
import {Cursor, Typewriter} from "react-simple-typewriter";
import MainTiltCard from './MainTiltCard';
import TopTiltCard from './TopTiltCard';
import BottomTiltCard from './BottomTiltCard';
import  MouseImageTrail  from './MouseImageTrail';
import trailImages from '../trailImages';

const socials = [...links.map((l) => [l.label, l.href]), ["Email", `mailto:${EMAIL}`]];

const Home = () => {

    return (
    <div>
      <h1>
        <Typewriter className = "typeWriter" words= {['.joyastick', '.js', 'aldric-joya.js']}/>
        <Cursor />
      </h1>
        
        <MouseImageTrail
      renderImageBuffer={150}
      rotationRange={25}
      images={trailImages}
    >
        <div className="relative z-[1000] mx-auto grid max-w-[1500px] grid-cols-[auto_auto] justify-center justify-items-center gap-x-3 gap-y-3 px-4 pb-24 pt-8 lg:flex lg:min-h-[calc(100vh-var(--nav-h))] lg:flex-row lg:items-center lg:justify-center lg:gap-10 lg:py-0 xl:gap-14">
          {/* left column (on small screens the columns dissolve and the order-* classes set the stacking order) */}
          <div className="contents lg:flex lg:flex-col lg:items-center lg:gap-6">
            <div className="order-2 row-span-2 self-center [zoom:var(--cz)] lg:order-none lg:self-auto lg:[zoom:1]"><MainTiltCard/></div>
            <div className="order-3 col-start-2 [zoom:var(--cz)] lg:order-none lg:[zoom:1]"><TopTiltCard/></div>
          </div>

          {/* center column */}
          <div className="contents lg:flex lg:w-[34rem] lg:flex-col lg:items-center lg:gap-6">
            <div className="logo-frost relative order-1 col-span-2 mb-5 w-fit px-10 py-14 sm:px-20 lg:order-none lg:mb-0 lg:px-16 lg:py-10">
              <img
                src={wordmark}
                alt="Joyastick"
                className="w-[min(60vw,36rem)] drop-shadow-md lg:w-[22rem] dark:hidden"
              />
              {/* the black-text logo disappears on dark green, so dark mode shows the orange one */}
              <img
                src={wordmarkOrange}
                alt="Joyastick"
                className="hidden w-[min(60vw,36rem)] drop-shadow-md lg:w-[22rem] dark:block"
              />
            </div>

            <p className="order-5 col-span-2 mt-5 max-w-4xl rounded-xl bg-emerald-100/75 px-6 py-4 text-center text-lg font-medium shadow-lg md:text-2xl lg:order-none lg:mt-0">
              I'm a software developer and video editor who builds tools for
              fighting games, from controller input readers to full game mods.
            </p>

            <div className="order-7 col-span-2 mt-5 flex flex-wrap justify-center gap-3 lg:order-none lg:mt-0">
              {socials.map(([label, href]) => (
                <a
                  key={label}
                  href={href}
                  {...(href.startsWith("http") && { target: "_blank", rel: "noreferrer" })}
                  className="inline-flex items-center gap-2 rounded-full bg-emerald-100/75 px-5 py-2 font-bold shadow-lg transition-transform hover:scale-105"
                >
                  {icons[label] && (
                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="h-4 w-4">
                      <path d={icons[label]} />
                    </svg>
                  )}
                  {label}
                </a>
              ))}
            </div>
          </div>

          {/* right column */}
          <div className="contents lg:flex lg:flex-col lg:items-center lg:gap-6">
            <div className="order-4 col-start-2 [zoom:var(--cz)] lg:order-none lg:[zoom:1]"><BottomTiltCard/></div>

            <div className="order-6 col-span-2 mt-5 grid w-full max-w-4xl grid-cols-1 gap-5 sm:grid-cols-2 lg:order-none lg:mt-0 lg:w-72 lg:grid-cols-1">
              {projects.filter((p) => p.featured !== false).map((p) => (
                <Link
                  key={p.title}
                  to="/projects"
                  className="flex items-center gap-4 rounded-xl bg-emerald-900/80 p-3 shadow-xl shadow-black/30 transition-transform hover:scale-[1.02]"
                >
                  <div className="flex flex-1 items-center gap-4 rounded-xl bg-emerald-100/75 p-4 shadow-lg lg:gap-3 lg:p-3">
                    <img src={p.icon} alt="" className="h-20 w-20 shrink-0 lg:h-14 lg:w-14" />
                    <div>
                      <p className="text-2xl font-bold lg:text-xl">{p.title}</p>
                      <p className="font-medium lg:text-sm">{p.tagline}</p>
                    </div>
                  </div>
                </Link>
              ))}
              <Link
                to="/projects"
                className="rounded-xl bg-emerald-900/80 p-3 text-center text-lg font-bold text-emerald-100 shadow-xl shadow-black/30 transition-transform hover:scale-[1.02] sm:col-span-2 lg:col-span-1"
              >
                More projects →
              </Link>
            </div>
          </div>
        </div>
    </MouseImageTrail>
    </div>
  );
}

export default transition(Home);
